// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 589 ? "saturday-course-finder" : chunkId) + "." + {"29":"66fdcfd4","510":"26e3ea49","589":"c2151667","675":"fa5918a2","694":"d6158336","985":"9b0a53c3"}[chunkId] + ".chunk.js";
};